<script>
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Title from "../components/Title.svelte";
  import Accordion from "../components/accordion/Accordion.svelte";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];
  let items = [];
  let itemsDisplay = false;
  axios
    .get(settings.url + "/sipade/histori", {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      items = response.data;
      itemsDisplay = true;
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("t");
        redirect("/login");
      } else {
        if (error.response.data.message) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: error.response.data.message,
              color: "orange",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        }
      }
    });
</script>

{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-10 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar backbtn="true" title="Riwayat" message={navigation["message"]} />
<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  <div class="max-w-6xl pt-2 mx-auto my-5 mt-0 lg:mt-10 md:mt-5 lg:my-0">
    <div class="lg:hidden">
      <Title subtitle="" title="Riwayat Pelayanan" />
    </div>
  </div>
  <div class="flex flex-wrap items-center max-w-3xl mx-auto my-5 lg:my-0 ">
    {#if itemsDisplay}
      {#if items.list}
        <ul class="w-full timeline">
          {#each items.list as p, i}
            <li>
              <div class="bg-teal-600 timeline-badge">
                <svg
                  class="w-full h-6 m-auto mt-1"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18
              14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543
              13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6
              8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4
              17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9
              18V17M15 17H9"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                class="relative p-4 mb-5 bg-gray-100 rounded-lg shadow timeline-panel easeAnimate hover:shadow-lg"
              >
                <div
                  class="pointer timeline-heading md:flex md:justify-between"
                >
                  <div>
                    <small class="text-xs text-gray-600">
                      #125 ~
                      {p.tanggal}
                      WIB
                    </small>
                    <h4 class="font-bold timeline-title">{p.pelayanan}</h4>
                  </div>
                  <div>
                    <small class="text-xs text-gray-600"> #Keterangan </small>
                    <p
                      class="mb-2 text-sm font-thin text-gray-600 md:text-base"
                    >
                      {p.keterangan}
                    </p>
                  </div>
                </div>
                <div class="timeline-body">
                  <Accordion
                    css="text-xs text-white bg-teal-600 float-left m-t-0  px-2 cursor-pointer hover:shadow-md rounded-l-none rounded-br-lg"
                    title={p.notif}
                  >
                    <div class="clearfix" />
                    <h3
                      class="mt-10 text-sm font-bold text-center text-gray-700"
                    >
                      Proses Pengajuan
                    </h3>
                    <ul class="mt-5 list-unstyled multi-steps tablist">
                      <li role="presentation" id="stepID1">
                        <span class="text-xs">
                          <b>Diajukan</b>
                          <br />
                          <span class="hidden md:inline-block"
                            >21-03-2020 03:12:00 WIB</span
                          >
                        </span>
                      </li>
                      <li role="presentation" id="stepID2">
                        <span class="text-xs">
                          <b>Diperiksa</b>
                          <br />
                          <span class="hidden md:inline-block"
                            >21-03-2020 03:12:00 WIB</span
                          >
                        </span>
                      </li>
                      <li role="presentation" id="stepID3">
                        <span class="text-xs">
                          <b>Diproses</b>
                          <br />
                          <span class="hidden md:inline-block"
                            >21-03-2020 03:12:00 WIB</span
                          >
                        </span>
                      </li>
                    </ul>

                    <h3
                      class="mt-10 text-sm font-bold text-center text-gray-700"
                    >
                      Proses Penyerahan
                    </h3>
                    <ul class="mt-5 list-unstyled multi-steps tablist">
                      <li role="presentation" id="stepID1" class="active">
                        <span class="text-xs">
                          <b>Dikirim</b>
                          <br />
                          <span class="hidden md:inline-block"
                            >21-03-2020 03:12:00 WIB</span
                          >
                        </span>
                      </li>
                      <li role="presentation" id="stepID2">
                        <span class="text-xs">
                          <b>Diterima</b>
                          <br />
                          <span class="hidden md:inline-block" />
                        </span>
                      </li>
                      <li role="presentation" id="stepID3">
                        <span class="text-xs">
                          <b>Selesai</b>
                          <br />
                          <span class="hidden md:inline-block" />
                        </span>
                      </li>
                    </ul>
                  </Accordion>
                </div>
              </div>
            </li>
          {/each}
        </ul>
      {:else}
        <p
          class="w-full p-5 font-light text-center text-gray-500 bg-white rounded shadow-md"
        >
          Belum ada riwayat pelayanan
        </p>
      {/if}
    {:else}
      <p
        class="w-full p-5 font-light text-center text-gray-500 bg-white rounded shadow-md"
      >
        Sepertinya Desa anda belum mendukung layanan ini
      </p>
    {/if}
  </div>
</main>
